import styled from 'styled-components'
import { border } from 'styled-system'
import { Box } from '@careguide/theme'
import css from '@styled-system/css'

const MainLoadingSkeleton = styled(Box)`
  display: block;
  position: relative;
  overflow: hidden;

  ::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 70%,
      rgba(255, 255, 255, 0)
    );
    animation: shimmer 1.5s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }

  ${border}
  ${css({ backgroundColor: 'gray.2' })}
`

const LoadingSkeleton = styled(MainLoadingSkeleton)`
  &::before {
    content: '\00a0';
  }
`

export default LoadingSkeleton
